import { Component, EventEmitter, HostListener, Input, OnInit, Output } from "@angular/core";


@Component({
  selector: 'app-info-action-3',
  templateUrl: './info-action-3.component.html',
  styleUrls: ['./info-action-3.component.css']
})
export class InfoAction3Component implements OnInit {

  @Input() action: any;
  @Output() closeInfoPopup = new EventEmitter<any>();
  @Input() acmNoBurned :Array<any>;

  /*********************EMISSION*************************/

  //CV
  emissionTreshold;//PTRE
  emissionTrasholdType;//PTRT
  emissionMaxCouponNumber;//PMCN
  ripetibleEmissionTreshold;//PRTR

  //LM TransactionFruitionLimit
  emissionTACM //TACM
  emissionPMCT  //PMCT

  //AC
  emissionAccumulator;//TACM
  emissionAccumulationRule;//JAAR
  emissionControlRule;//JACR
  //cambiamenti
  emissionAccumulatorToMove;
  emissionAccumulatorToControl;

  //CT
  distributionEmissionList; //TDIS;

  //OL
  touchPointEmission;//TOCH

  //PT
  basket;
  productDepartment;
  productCategory;
  productItem;

  //WZ
  wizardEmission;

  /*********************FRUITION*************************/

  //CV fruition
  fruitionTreshold//PTRE
  fruitionTrasholdType;//PTRT
  fruitionMaxCouponNumber;//PMCN
  ripetibleFruitionTreshold;//PRTR

  //LM fruition
  fruitionPMCT: string;
  fruitionTACM: any;

  //CT fruition
  distributionFruitionList;

  //AC fruition
  fruitionAccumulator;//TACM;
  fruitionAccumulationRule;//JAAR
  fruitionControlRule;//JACR
  //nuovi

  fruitionAccumulatorToMove;
  fruitionAccumulatorToControl;

  

  //OL
  touchPointFruition;//TOCH

  //PT
  basketFruition;
  productDepartmentFruition;
  productCategoryFruition;
  productItemFruition;

  //WZ
  wizardFruition

  /*********************COMMON*************************/

  //BA
  productItemBarcodeAttivazione;//TBCD
  eanBarcodeAttivazione;//PBCD

  //BC
  productItemBarcodeCupon;//TBCD
  eanBarcodeCoupon;//PBCD



  /******************FRONTEND-DATA***********************/

  //date
  startFruitionDate;
  endFruitionDate;

  //date
  startEmissionDate;
  endEmissionDate;

  //bodyInfo
  id;
  actionType;
  name;
  discountType;
  generationMethod;
  targetLoyaltyClass;
  description;
  actualGeneratedCoupon


  //appositi per semplificare html del popup
  barcodeCoupon;
  barcodeAttivazione;
  accumulatoriEmissione;
  accumulatoriFruizione;
  listaDistribuzioneEmissione;
  listaDistribuzioneFruizione;
  targetArticoliEmissione;
  targetArticoliFruizione;
  touchPointEmissione;
  touchPointFruizione;
  numeroNegoziEmissione;
  numeroNegoziFruizione;
  sogliaDiEmissione: { type: string, value: number };
  sogliaDiFruizione: { type: string, value: number };
  emissioneRipetibile: { type: string, value: number, max: number };
  fruizioneRipetibile: { type: string, value: number, max: number };

  summaryAccumulatorToMove: any[] = [];
  summaryAccumulatorToControl: any[] = [];

  summaryAccumulatorToMoveFruition: any[] = [];
  summaryAccumulatorToControlFruition: any[] = [];


  wizardEmissione :string;
  wizardFruizione :string;

  ngOnInit(): void {
    console.log("inizializzato info");
    console.log(this.action)
    this.processActionData();
  }


  constructor() {
    this.sogliaDiEmissione = { type: '', value: 0 };
    this.sogliaDiFruizione = { type: '', value: 0 };
    this.emissioneRipetibile = { type: '', value: 0, max: 0 };
    this.fruizioneRipetibile = { type: '', value: 0, max: 0 };
  }

  processActionData() {
    if (!this.action || !this.action.data) {
      console.error("Error: Missing data object in action.");
    }

    let localData = this.action.data

    this.mapBodyData(localData);

    this.countStores(localData);

    this.mapInstanceData(localData);

    this.frontEndLogic(localData);

    this.logAllData();
  }
  fruitionRolling:boolean =false;
  mapBodyData(localData: any) {

    this.startEmissionDate = localData.startEmissionDate;
       
    if(localData.couponValidityDateEndMode || localData.couponValidityDateEndMode){
      this.fruitionRolling=true;
    }
    this.endEmissionDate = localData.endEmissionDate;
    this.startFruitionDate = localData.startFruitionDate;
    this.endFruitionDate = localData.endFruitionDate;
    this.actionType = localData.actionType;
    this.name = localData.name;
    this.discountType = localData.discountType;
    //this.description = localData.description;
    this.description = localData.couponAmt;
    this.actualGeneratedCoupon = localData.actualGeneratedCoupon;
    this.id = localData.id;

  }
//KS-7755

  countStores_OLD(data: any) {


    if (data.storeMessageOChannel) {
      let storeMessageList = data.storeMessageOChannel;
      let emission = [];
      let fruition = [];
      for (let record of storeMessageList) {
        if (record.storeType == 'E') {
          emission.push(record);
        }
        if (record.storeType == 'F') {
          fruition.push(record);
        }
      }
      this.numeroNegoziEmissione = emission.length;
      this.numeroNegoziFruizione = fruition.length;

    } else {
      this.numeroNegoziEmissione = 0
      this.numeroNegoziFruizione = 0
    }



  }

  countStores(data: any) {
  if (data.storeMessageOChannel) {
    let storeMessageList = data.storeMessageOChannel;
    let emission = [];
    let fruition = [];

    for (let record of storeMessageList) {
      if (record.flg_state !== "0") continue;

      if (record.storeType == 'E') {
        emission.push(record);
      }
      if (record.storeType == 'F') {
        fruition.push(record);
      }
    }

    this.numeroNegoziEmissione = emission.length;
    this.numeroNegoziFruizione = fruition.length;

  } else {
    this.numeroNegoziEmissione = 0;
    this.numeroNegoziFruizione = 0;
  }
}



  mapInstanceData(data: any) {
    let messageInstanceRule = data.messageInstanceRule;

    //CV list
    let cvInstanceRuleDetail;
    let cvInstanceRuleDetailFruition;

    //LM List
    let lmInstanceRuleList;
    let lmInstanceRuleListFruition;

    //AC List
    let acInstanceRuleDetail;
    let acInstanceRuleDetailFruition;

    //BA List
    let baInstanceRuleDetail;

    //BC List
    let bcInstanceRuleDetail;

    //CT List
    let ctInstanceRuleDetail;
    let ctInstanceRuleDetailFruition;

    //OL List
    let olEmissionInstanceRuleDetail;
    let olFruitionInstanceRuleDetail;

    //PT List
    let ptInstanceRuleDetail;
    let ptInstanceRuleDetailFruition;

    //WZ List
    let wizardInstanceRuleDetail;
    let wizardInstanceRuleDetailFruition;




    for (let data of messageInstanceRule) {

      /*------------------------------CV--------------------------------*/

      //lista coupon con cv
      if (data.ruleType == "CV" && data.ruleScope == "emission") {
        cvInstanceRuleDetail = data.messageInstanceRuleDetail;
      }
      //lista coupon con cv fruizione
      if (data.ruleType == "CV" && data.ruleScope == "fruition") {
        cvInstanceRuleDetailFruition = data.messageInstanceRuleDetail;
      }

      /*------------------------------LM--------------------------------*/

      //lista coupon con cv
      if (data.ruleType == "CV" && data.ruleScope == "emission") {
        lmInstanceRuleList = data.messageInstanceRuleDetail;
      }
      //lista coupon con cv fruizione
      if (data.ruleType == "CV" && data.ruleScope == "fruition") {
        lmInstanceRuleList = data.messageInstanceRuleDetail;
      }

      /*------------------------------AC--------------------------------*/

      //lista accumulatori
      if (data.ruleType == "AC" && data.ruleScope == "emission") {
        acInstanceRuleDetail = data.messageInstanceRuleDetail;
      }

      //lista accumulatori fruition
      if (data.ruleType == "AC" && data.ruleScope == "fruition") {
        acInstanceRuleDetailFruition = data.messageInstanceRuleDetail;
      }

      /*------------------------------CT--------------------------------*/

      //lista customer target emission
      if (data.ruleType == "CT" && data.ruleScope == "emission") {
        ctInstanceRuleDetail = data.messageInstanceRuleDetail;
      }

      //lista customer target fruition
      if (data.ruleType == "CT" && data.ruleScope == "fruition") {
        ctInstanceRuleDetailFruition = data.messageInstanceRuleDetail;
      }

      /*------------------------------OL--------------------------------*/


      if (data.ruleType == "OL" && data.ruleScope == "emission") {
        olEmissionInstanceRuleDetail = data.messageInstanceRuleDetail;
      }

      //lista touchPointFruition
      if (data.ruleType == "OL" && data.ruleScope == "fruition") {
        olFruitionInstanceRuleDetail = data.messageInstanceRuleDetail;
      }

      /*---------------------------BA & BC------------------------------*/

      //lista barcode attivatore
      if (data.ruleType == "BA" && data.ruleScope == "emission") {
        baInstanceRuleDetail = data.messageInstanceRuleDetail;
      }
      //lista barcode coupon
      if (data.ruleType == "BC" && data.ruleScope == "emission") {
        bcInstanceRuleDetail = data.messageInstanceRuleDetail;

      }

      /*------------------------------WZ--------------------------------*/


      //lista wizarEmission
      if (data.ruleType == "WZ" && data.ruleScope == "emission") {

        wizardInstanceRuleDetail = data.messageInstanceRuleDetail;
      }
      //lista wizard
      if (data.ruleType == "WZ" && data.ruleScope == "fruition") {

        wizardInstanceRuleDetailFruition = data.messageInstanceRuleDetail;
      }

      /*------------------------------PT--------------------------------*/

      // lista per targetArticoliEmissione
      if (data.ruleType == "PT" && data.ruleScope == "emission") {
        ptInstanceRuleDetail = data.messageInstanceRuleDetail;
      }
      // lista per targetArticoliFruizione
      if (data.ruleType == "PT" && data.ruleScope == "fruition") {
        ptInstanceRuleDetailFruition = data.messageInstanceRuleDetail;
      }

    }

    /***********************CV**************************/
    //dettagli del CV emissione
    if (cvInstanceRuleDetail) {

      for (let record of cvInstanceRuleDetail) {

        if (record && record.objectTypeCode == "PTRE") {
          this.emissionTreshold = record.objectValue / 100;
        }
        if (record && record.objectTypeCode == "PTRT") {
          this.emissionTrasholdType = record.objectValue;
        }
        if (record && record.objectTypeCode == "PMCN") {
          this.emissionMaxCouponNumber = record.objectValue;
        }
        if (record && record.objectTypeCode == "PRTR") {
          this.ripetibleEmissionTreshold = record.objectValue;
        }
        //
      }
    }
    //dettagli del CV fruizione
    if (cvInstanceRuleDetailFruition) {
      for (let record of cvInstanceRuleDetailFruition) {
        //emissionTreshold fruizione
        if (record && record.objectTypeCode == "PTRE") {
          this.fruitionTreshold = record.objectValue / 100;
        }
        if (record && record.objectTypeCode == "PTRT") {
          this.fruitionTrasholdType = record.objectValue;
        }
        if (record && record.objectTypeCode == "PMCN") {
          this.fruitionMaxCouponNumber = record.objectValue;
        }
        if (record && record.objectTypeCode == "PRTR") {
          this.ripetibleFruitionTreshold = record.objectValue/100;
        }

      }
    }
    /***********************LM**************************/


    if (lmInstanceRuleList) {
      for (let record of lmInstanceRuleList) {
        if (record && record.objectTypeCode == "TACM") {

          this.emissionTACM = record.description;
        }
        if (record && record.objectTypeCode == "PMCT") {
          //TODO attenzione campo complesso
          this.emissionPMCT = 'campo complesso TODO';
        }
      }
    }

    if (lmInstanceRuleListFruition) {
      for (let record of lmInstanceRuleListFruition) {
        if (record && record.objectTypeCode == "TACM") {

          this.fruitionTACM = record.description;
        }
        if (record && record.objectTypeCode == "PMCT") {
          //TODO attenzione campo complesso
          this.fruitionPMCT = 'campo complesso TODO';
        }
      }
    }

    /***********************AC**************************/

   /*  if (acInstanceRuleDetail) {
      for (let record of acInstanceRuleDetail) {
        if (record && record.objectTypeCode == "TACM") {

          this.emissionAccumulator = record.description;
        }
        if (record && record.objectTypeCode == "JAAR") {

          this.emissionAccumulationRule = record.objectJson;
        }
        if (record && record.objectTypeCode == "JACR") {

          this.emissionControlRule = record.objectJson;
        }

      }
    } */
    if (acInstanceRuleDetail) {
      for (let record of acInstanceRuleDetail) {
 
        if (record && record.objectTypeCode == "JAAR") {

          this.emissionAccumulatorToMove = record.objectJson;
        }
        if (record && record.objectTypeCode == "JACR") {
          this.emissionAccumulatorToControl = record.objectJson;
        }

      }
    }
/* 
    if (acInstanceRuleDetailFruition) {
      for (let record of acInstanceRuleDetailFruition) {
        if (record && record.objectTypeCode == "TACM") {

          this.fruitionAccumulator = record.description;
        }
        if (record && record.objectTypeCode == "JAAR") {

          this.fruitionAccumulationRule = record.objectJson;
        }
        if (record && record.objectTypeCode == "JACR") {

          this.fruitionControlRule = record.objectJson;
        }

      }
    } */

     
     if (acInstanceRuleDetailFruition) {
       
      for (let record of acInstanceRuleDetailFruition) {
      
        if (record && record.objectTypeCode == "JAAR") {

          this.fruitionAccumulatorToMove = record.objectJson;
        }
        if (record && record.objectTypeCode == "JACR") {

          this.fruitionAccumulatorToControl = record.objectJson;
        }

      }
    }

    /***********************BA**************************/

    //dettagli di barcodeAttivazione
    if (baInstanceRuleDetail) {
      for (let record of baInstanceRuleDetail) {
        if (record && record.objectTypeCode == "TBCD") {

          this.productItemBarcodeAttivazione = record.objectValue;
        }
        if (record && record.objectTypeCode == "PBCD") {

          this.eanBarcodeAttivazione = record.objectValue;
        }
      }
    }
    /***********************BC**************************/
    //dettagli di productItemBarcodeCupon

    if (bcInstanceRuleDetail) {
      for (let record of bcInstanceRuleDetail) {
        if (record && record.objectTypeCode == "TBCD") {

          this.productItemBarcodeCupon = record.objectValue;
        }
        if (record && record.objectTypeCode == "PBCD") {

          this.eanBarcodeCoupon = record.objectValue;
        }
      }
    }





    /***********************CT**************************/

    //dettagli di distributionEmissionList
    if (ctInstanceRuleDetail) {
      for (let record of ctInstanceRuleDetail) {
        if (record && record.objectTypeCode == "TDIS") {

          this.distributionEmissionList = record.description;
        }
      }
    }
    //dettagli di distributionEmissionListFruition
    if (ctInstanceRuleDetailFruition) {
      for (let record of ctInstanceRuleDetailFruition) {
        if (record && record.objectTypeCode == "TDIS") {

          this.distributionFruitionList = record.description;
        }
      }
    }


    /***********************OL**************************/

    //dettagli di touchpointEmission
    if (olEmissionInstanceRuleDetail) {
      for (let record of olEmissionInstanceRuleDetail) {
        if (record && record.objectTypeCode == "TOCH") {

          this.touchPointEmission = record.description;
        }

      }
    }
    //dettagli di touchPointFruition
    if (olFruitionInstanceRuleDetail) {
      for (let record of olFruitionInstanceRuleDetail) {
        if (record && record.objectTypeCode == "TOCH") {

          this.touchPointFruition = record.description;
        }

      }
    }

    /***********************PT**************************/

    //Chiedere come trattare INCLUDE e EXCLUDE

    if (ptInstanceRuleDetail) {

      for (let record of ptInstanceRuleDetail) {

        if (record && record.objectTypeCode == "TBSK") {
          this.basket = record.description;
        }
        if (record && record.objectTypeCode == "TDEP") {
          this.productDepartment = record.description;
        }
        if (record && record.objectTypeCode == "TCAT") {
          this.productCategory = record.description;
        }
        if (record && record.objectTypeCode == "TPRD") {
          this.productItem = record.description;
        }

      }
    }

    if (ptInstanceRuleDetailFruition) {

      for (let record of ptInstanceRuleDetailFruition) {

        if (record && record.objectTypeCode == "TBSK") {
          this.basketFruition = record.description;

        }
        if (record && record.objectTypeCode == "TDEP") {
          this.productDepartmentFruition = record.description;
        }
        if (record && record.objectTypeCode == "TCAT") {
          this.productCategoryFruition = record.description;
        }
        if (record && record.objectTypeCode == "TPRD") {
          this.productItemFruition = record.description;
        }

      }
    }


    /***********************WZ**************************/
    //TODO per ora prelevo e displayo l'objectTypeId vedere se effettuare ulteriori elaborazioni sul dato (riportare anche su parte di ferderico della validazione)

    if (wizardInstanceRuleDetail) {
      this.wizardEmission = [];  
      for (let record of wizardInstanceRuleDetail) {
        if (record && record.objectTypeCode == "TWIZ") {
          this.wizardEmission.push(record); 
        }
      }
    }



    if (wizardInstanceRuleDetailFruition) {
      this.wizardFruition = [];  
      for (let record of wizardInstanceRuleDetailFruition) {
        if (record && record.objectTypeCode == "TWIZ") {
          this.wizardFruition.push(record);  
        }
      }
    }
  }






  /* Temp variaable da spostare su */
  couponingMethodMap = {
    'D': 'Dinamico',
    'S': 'Statico'
  };
  customerTarget = {
    'LOY': 'Loyalty',
    'ALL': 'Tutti',
    'NoLoy': 'No Loyalty'
  };
  variableDates: boolean = false;
  
  frontEndLogic(localData: any) {
     
    if (localData.flgRolling == "1") {
      this.variableDates = true;
    }



    this.generationMethod = this.couponingMethodMap[localData.flgCouponingMethod] || '';
    this.targetLoyaltyClass = this.customerTarget[localData.targetLoyaltyClass] || '';

    //Barcode Attivazione
    if (this.productItemBarcodeAttivazione) {
      this.barcodeAttivazione = this.productItemBarcodeAttivazione;
    } else if (this.eanBarcodeAttivazione) {
      this.barcodeAttivazione = this.eanBarcodeAttivazione;
    }
    if (!this.barcodeAttivazione) {
      this.barcodeAttivazione = 'No';
    }
    //Barcode Coupon
    if (this.productItemBarcodeCupon) {
      this.barcodeCoupon = this.productItemBarcodeCupon;
    } else if (this.eanBarcodeCoupon) {
      this.barcodeCoupon = this.eanBarcodeCoupon;
    }
    if (!this.barcodeCoupon) {
      this.barcodeCoupon = 'No';
    }

    //Accumulatori in emissione 
    if (this.emissionAccumulator) {
      this.accumulatoriEmissione = 'Si' + this.emissionAccumulator;
    } else {
      this.accumulatoriEmissione = 'No';
    }

    //Accumulatori in fruizione 
    if (this.fruitionAccumulator) {
      this.accumulatoriFruizione = 'Si' + this.fruitionAccumulator;
    } else {
      this.accumulatoriFruizione = 'No';
    }

    //listaDistribuzioneEmissione
    if (this.distributionEmissionList) {
      this.listaDistribuzioneEmissione = 'Si' + '(' + this.distributionEmissionList + ')';
    }
    else {
      this.listaDistribuzioneEmissione = 'No';
    }

    //listaDistribuzioneFruizione
    if (this.distributionFruitionList) {
      this.listaDistribuzioneFruizione = 'Si' + '(' + this.distributionFruitionList + ')';
    }
    else {
      this.listaDistribuzioneFruizione = 'No';
    }


    //TODO targetArticoli emissione valutare come fare fiocchetti
    if (this.basket || this.productDepartment || this.productCategory || this.productItem) {
      this.targetArticoliEmissione = (this.basket || '') + (this.productDepartment || '') + (this.productCategory || '') + (this.productItem || '');
    } else {
      this.targetArticoliEmissione = 'no';
    }
    //TODO targetArticoliFruizione emissione valutare come fare fiocchetti
    if (this.basketFruition || this.productDepartmentFruition || this.productCategoryFruition || this.productItemFruition) {
      this.targetArticoliFruizione = (this.basketFruition || '') + (this.productDepartmentFruition || '') + (this.productCategoryFruition || '') + (this.productItemFruition || '');
    } else {
      this.targetArticoliFruizione = 'no';
    }

    //Touchpoint Emissione
    if (this.touchPointEmission) {
      this.touchPointEmissione = this.touchPointEmission;
    } else {
      this.touchPointEmissione = 'No';
    }
    //Touchpoint Fruizione
    if (this.touchPointFruition) {
      this.touchPointFruizione = this.touchPointFruition;
    } else {
      this.touchPointFruizione = 'No';
    }



    //sogliaDiEmissione 
    if (this.emissionTrasholdType && this.emissionTrasholdType == "EV") {

      this.sogliaDiEmissione.type = 'Valore';
      this.sogliaDiEmissione.value = this.emissionTreshold;
    }
    //sogliaDiEmissione 
    if (this.emissionTrasholdType && this.emissionTrasholdType == "EQ") {

      this.sogliaDiEmissione.type = 'Quantità';
      this.sogliaDiEmissione.value = this.emissionTreshold;
    }
    if (!this.emissionTrasholdType) {
      this.sogliaDiEmissione.type = 'No';
    }


    //sogliaDiFruizioneTODO
    if (this.fruitionTrasholdType && this.fruitionTrasholdType == "EV") {
      this.sogliaDiFruizione.type = 'Valore';
      this.sogliaDiFruizione.value = this.fruitionTreshold;
    }
    if (this.fruitionTrasholdType && this.fruitionTrasholdType == "EQ") {
      this.sogliaDiFruizione.type = 'Quantità';
      this.sogliaDiFruizione.value = this.fruitionTreshold;
    }
    if (!this.fruitionTrasholdType) {
      this.sogliaDiFruizione.type = 'No';
    }

    //Emissione Ripetibile
    if (this.ripetibleEmissionTreshold) {
      this.emissioneRipetibile.type = "si";
      const intValue = parseInt(this.emissionMaxCouponNumber);
      if (!isNaN(intValue)) {
        this.emissioneRipetibile.value = intValue / 100;
        this.emissioneRipetibile.max = intValue;
      } else {
        console.error("record.objectValue non è un numero valido");
      }
    } else {
      this.emissioneRipetibile.type = "No";
    }

    //Fruizione Ripetibile
    if (this.ripetibleFruitionTreshold) {
      this.fruizioneRipetibile.type = "si";
      const intValue = parseInt(this.fruitionMaxCouponNumber);
      if (!isNaN(intValue)) {
        this.fruizioneRipetibile.value = intValue / 100;
        this.fruizioneRipetibile.max = intValue;
      } else {
        console.error("record.objectValue non è un numero valido");
      }
    } else {
      this.fruizioneRipetibile.type = "No";
    }



    //Wizard
    if (this.wizardEmission) {
      let wizardEmissionArray = [];
      this.wizardEmission.forEach(el => {
        wizardEmissionArray.push(el.description);
      })
      this.wizardEmissione = wizardEmissionArray.join(', ');
    } else {
      this.wizardEmissione = "nessuno"
    }
    if (this.wizardFruition) {
      let wizardFruitionArray =[];
      this.wizardFruition.forEach(el => {
        wizardFruitionArray.push(el.description);
      })
    
      this.wizardFruizione = wizardFruitionArray.join(', ');
    } else {
      this.wizardFruizione = "nessuno"
    }

    //Accumulatori EMISSIONE
 // --- Controllo (JACR) ---
  if (this.emissionAccumulatorToControl && Array.isArray(this.emissionAccumulatorToControl.check)) {
    const checkList = this.emissionAccumulatorToControl.check;
    for (let check of checkList) {
      const matchingAccumulator = this.acmNoBurned.find(acc => acc.id == check.acm_id);

      if (matchingAccumulator) {
        console.log('Trovato (controllo):', matchingAccumulator);
        this.summaryAccumulatorToControl.push(matchingAccumulator);
      } else {
        console.warn('Accumulatore non trovato per ID (controllo):', check.acm_id);
      }
    }
  }

  // --- Movimentazione (JAAR) ---
  if (this.emissionAccumulatorToMove && Array.isArray(this.emissionAccumulatorToMove.move)) {
    const moveList = this.emissionAccumulatorToMove.move;

    for (let move of moveList) {
      const matchingAccumulator = this.acmNoBurned.find(acc => acc.id == move.acm_id);

      if (matchingAccumulator) {
        console.log('Trovato (movimento):', matchingAccumulator);
        this.summaryAccumulatorToMove.push(matchingAccumulator);
      } else {
        console.warn('Accumulatore non trovato per ID (movimento):', move.acm_id);
      }
    }
  }


  //FRUIZIONE

   // --- Controllo (JACR) ---
  if (this.fruitionAccumulatorToControl && Array.isArray(this.fruitionAccumulatorToControl.check)) {
    const checkList = this.fruitionAccumulatorToControl.check;

    for (let check of checkList) {
      const matchingAccumulator = this.acmNoBurned.find(acc => acc.id == check.acm_id);
      if (matchingAccumulator) {
        console.log('Trovato (controllo):', matchingAccumulator);
        this.summaryAccumulatorToControlFruition.push(matchingAccumulator);
      } else {
        console.warn('Accumulatore non trovato per ID (controllo):', check.acm_id);
      }
    }
  }
   
  // --- Movimentazione (JAAR) ---
  if (this.fruitionAccumulatorToMove && Array.isArray(this.fruitionAccumulatorToMove.move)) {
    const moveList = this.fruitionAccumulatorToMove.move;
     
    for (let move of moveList) {
      const matchingAccumulator = this.acmNoBurned.find(acc => acc.id == move.acm_id);
       
      if (matchingAccumulator) {
        console.log('Trovato (movimento):', matchingAccumulator);
        this.summaryAccumulatorToMoveFruition.push(matchingAccumulator);
      } else {
        console.warn('Accumulatore non trovato per ID (movimento):', move.acm_id);
      }
    }
  }
}

  logAllData() {

    console.log("barcodeCoupon:", this.barcodeCoupon);
    console.log("barcodeAttivazione:", this.barcodeAttivazione);
    console.log("accumulatoriEmissione:", this.accumulatoriEmissione);
    console.log("accumulatoriFruizione:", this.accumulatoriFruizione);
    console.log("listaDistribuzioneEmissione:", this.listaDistribuzioneEmissione);
    console.log("listaDistribuzioneFruizione:", this.listaDistribuzioneFruizione);
    console.log("targetArticoliEmissione:", this.targetArticoliEmissione);
    console.log("targetArticoliFruizione:", this.targetArticoliFruizione);
    console.log("touchPointEmissione:", this.touchPointEmissione);
    console.log("touchPointFruizione:", this.touchPointFruizione);
    console.log("numeroNegoziEmissione:", this.numeroNegoziEmissione);
    console.log("numeroNegoziFruizione:", this.numeroNegoziFruizione);
    console.log("sogliaDiEmissione:", this.sogliaDiEmissione);
    console.log("sogliaDiFruizione:", this.sogliaDiFruizione);
    console.log("emissioneRipetibile:", this.emissioneRipetibile);
    console.log("fruizioneRipetibile:", this.fruizioneRipetibile);
    console.log("actionType:", this.actionType);
    console.log("name:", this.name);
    console.log("discountType:", this.discountType);
    console.log("generationMethod:", this.generationMethod);
    console.log("targetLoyaltyClass:", this.targetLoyaltyClass);
    console.log("description:", this.description);


  }


  

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/info-action-3/info-action-3.component.ts